"use client";

import { TextShimmer } from "@/components/text-shimmer";
import { Button } from "@/components/ui/button";
import { buildAiPlannerHotelNavigationContext } from "@/feature/ai-planner/lib/chat-hotel.utils";
import type {
  AiChatPayloadDataByType,
  AiHotel,
} from "@/feature/ai-planner/types/ai-chat.types";
import {
  setHotelPage,
  setSelectHotel,
} from "@/feature/hotel/checkout/state/hotel-data.slice";
import { useAppDispatch } from "@/redux/hooks";
import { ChevronsRight } from "lucide-react";
import { useRouter } from "next/navigation";
import { memo, useMemo, useTransition } from "react";

type HotelSearchResultData = AiChatPayloadDataByType<"HOTEL_SEARCH_RESULT">;

export const ChatHotelAvailabilityButton = memo(
  function ChatHotelAvailabilityButton({
    hotel,
    data,
  }: {
    hotel: AiHotel;
    data?: HotelSearchResultData;
  }) {
    const dispatch = useAppDispatch();
    const router = useRouter();
    const [isPending, startTransition] = useTransition();
    const navigationContext = useMemo(
      () => buildAiPlannerHotelNavigationContext(hotel, data),
      [data, hotel],
    );

    if (!navigationContext) {
      return null;
    }

    const handleAvailability = () => {
      dispatch(setSelectHotel(navigationContext.selectedHotel));
      dispatch(setHotelPage("hotel-details"));
      startTransition(() => {
        router.push(navigationContext.routePath);
      });
    };

    return (
      <div className="mt-3 flex justify-end border-t border-border/80 pt-3">
        <Button type="button" onClick={handleAvailability} className="rounded-xl">
          {isPending ? (
            <TextShimmer>See availability</TextShimmer>
          ) : (
            "See availability"
          )}
          <ChevronsRight />
        </Button>
      </div>
    );
  },
);
